module.exports = __webpack_public_path__ + "fonts/UniSansSemiBoldItalic.ba1ecbc1.eot";